<div class="scroll-container" (click)="scrollToTop()" *ngIf="pageOffset > 0">
  <img [matTooltip]="'Jump to top'" [matTooltipPosition]="'before'" class="icon" src="/assets/images/icons8-slide-up-64.png">
</div>